// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { FileKind } from "../../../define/FileKind";
import ModelDialogLayer from "../../../gameCommon/basic/ModelDialogLayer";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import EscortGoods1GamePeople from "./EscortGoods1GamePeople";

const {ccclass, property} = cc._decorator;

@ccclass
export default class EscortGoods1GameLayer extends BasePopUpLayer {

    @property(cc.Node)
    labelDropGoods: cc.Node = null;
    @property(cc.Node)
    nodeGoods: cc.Node = null;
    @property(cc.Node)
    nodeGoodsList: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeCar: cc.Node = null;
	@property({ type: cc.Node, displayName:'' })
	nodeCarList: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodePeople: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelDownTime: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelAward: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelDeduct: cc.Label = null;

    private csvInfo: any = null;
    private downTime = 0;
    private bStartGame = false;
    private upDt = 0;

    /** 杀死平民数量 */
    private killCivilianCount = 0;
    /** 杀死劫匪数量 */
    private killBanditCount = 0;
    /** 放过劫匪数量 */
    private letOffBanditCount = 0;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        let eid = this._carryData.id;
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(
            CsvFileKind.CsvFile.ESCORT_GOODS1
            , eid
        );
        if (!this.csvInfo) {
            console.error(`未找到表格数据 ESCORT_GOODS1 id = ` + eid);
            return;
        }
        
        this.initLayer();
    }

    initLayer() {
        this.labelDropGoods.active = false;
        this.nodeGoods.active = false;
        this.nodeCar.active = false;
        let deduct_award = Number(this.csvInfo.deduct_award);
        this.labelDeduct.string = '-' + data_control.getNumberFormat(deduct_award);
        
        let award = Number(this.csvInfo.award);
        this.labelAward.string = data_control.getNumberFormat(award);
        this.downTime = Number(this.csvInfo.down_time);

        this.nodePeople.children.forEach((v)=> {
            v.active = false;
        });

        this.refreshTime();
        this.startGame();
    }

    startGame() {
        this.bStartGame = true;
        this.startCarAction();
        this.startPeopleAction();
    }

    endGame() {
        this.bStartGame = false;
        cc.Tween.stopAllByTarget(this.nodeCarList);
        cc.Tween.stopAllByTarget(this.nodePeople);
        
        this.openResultLayer();
    }

    openResultLayer() {
        utilsView.openPopupLayer(
            'prefab/EscortGoodsResultLayer'
            , BUNDLE_SMALL_NAME.escortGoods1Bundle
            , null
            , {
                parent: this
                , killCivilianCount: this.killCivilianCount
                , killBanditCount: this.killBanditCount
                , letOffBanditCount: this.letOffBanditCount
                , csvInfo: this.csvInfo
            }
            , UI_Z_INDEX.DIALOG
        )
    }

    startCarAction() {
        cc.tween(this.nodeCarList)
        .call(this.createCar.bind(this))
        .delay(4)
        .union()
        .repeatForever()
        .start();
    }

    createCar() {
        let winSize = cc.winSize;
        let pos = this.nodeCarList.convertToNodeSpaceAR(cc.v2(0,0));
        let endPos = this.nodeCarList.convertToNodeSpaceAR(cc.v2(0,winSize.height));
        

        let nodeCar = cc.instantiate(this.nodeCar);
        nodeCar.active = true;
        this.nodeCarList.addChild(nodeCar);
        
        let maxH = endPos.y + nodeCar.height/2 + 10;
        nodeCar.y = pos.y - nodeCar.height/2 - 10;
        cc.tween(nodeCar)
        .to(20, {y: maxH})
        .removeSelf()
        .start();
    }

    startPeopleAction() {
        let delayTime = Number(this.csvInfo.time_space);

        cc.tween(this.nodePeople)
        .delay(delayTime)
        .call(this.arisePeople.bind(this))
        .union()
        .repeatForever()
        .start();
    }

    arisePeople() {
        let meanwhile_count: string = this.csvInfo.meanwhile_count;
        let range = meanwhile_count.split(FileKind.ResParseType.SUB_ITEM);
        let min = Number(range[0]);
        let max = Number(range[1]);
        let count = data_control.randomNumInt(min, max);

        let children = this.nodePeople.children;
        let len = children.length;
        let posList = data_control.randomIntNum(0, len-1, count);
        let showTime = Number(this.csvInfo.exist_time);
        
        const banditProb = 0.7;
        for (let o of posList) {
            let nodePeople = children[o];
            nodePeople.active = true;
            let script = nodePeople.getComponent(EscortGoods1GamePeople);
            // 强盗
            let bBandit = data_control.isHitProbability(banditProb);
            script.startArise(bBandit, showTime, this);
        }
    }

    killCivilian() {
        if (!this.bStartGame) {
            return;
        }
        this.killCivilianCount ++;
    }

    killBandit() {
        if (!this.bStartGame) {
            return;
        }
        this.killBanditCount++;
    }

    letOffBandit() {
        if (!this.bStartGame) {
            return;
        }
        this.letOffBanditCount++;
        this.labelDropGoods.active = false;

        let children = this.nodeCarList.children;
        if (children.length > 2) {
            let goodsId = this.getDropGoods();
            if (utilsModel.isValidNumberValue(goodsId)) {
                let idx = data_control.randomNumInt(1, children.length - 1);
                let nodeItem = children[idx];
                let textItem = cc.instantiate(this.labelDropGoods);
                textItem.active = true;
                textItem.parent = nodeItem;
                textItem.position = cc.v3(0, 0, 0);

                let tm = 0.35;
                cc.tween(textItem)
                .delay(0.7)
                .parallel(
                    cc.tween(nodeItem).to(tm, {opacity: 50})
                    , cc.tween(nodeItem).to(tm, {y: 50})
                )
                .removeSelf()
                .start();

                this.showDropGoods(goodsId, nodeItem.convertToWorldSpaceAR(cc.v2()));

            }
        }
    }

    async showDropGoods(
        goodsId: string
        , pos: cc.Vec2
    ) {
        let ePos = this.nodeGoodsList.convertToNodeSpaceAR(pos);
        let nodeItem = cc.instantiate(this.nodeGoods);
        nodeItem.active = false;
        nodeItem.setPosition(ePos);
        let spriteItem = nodeItem.getComponent(cc.Sprite);
        this.nodeGoodsList.addChild(nodeItem);

        let btnItem = nodeItem.getComponent(cc.Button);
        btnItem.clickEvents[0].customEventData = goodsId;

        let goodsConfig = backPackEventMap()[goodsId];
        let spPath = goodsConfig.spPath;
        let iconPath = "backpackAssets/objSp/" + spPath;
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
        bundle.load(iconPath, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    spriteItem.node.active = true;
                    spriteItem.spriteFrame = imgs; 

                    let bLeft = data_control.isHitProbability(0.5);
                    let dPos = bLeft ? -126 : 126;

                    cc.tween(nodeItem)
                    .bezierTo(0.5, ePos, cc.v2(ePos.x + (dPos/2), ePos.y + 200), cc.v2(ePos.x + dPos, ePos.y))
                    .start();
                }
            }
        );
    }

    onClickGoods(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        NormalGameManager._instance.onPushGoods(data, 1);

        let nodeItem = event.getCurrentTarget();
        let epos = nodeItem.parent.convertToNodeSpaceAR(O1HD.getManagers().gameMgr.chaoPiaoInitPos);
        cc.tween(nodeItem)
        .to(0.35, {x: epos.x, y: epos.y})
        .removeSelf()
        .start();
    }

    getDropGoods() {
        let drop_goods = this.csvInfo.drop_goods;
        let goodsList = utilsModel.splitLineFeed(drop_goods);
        for (let o of goodsList) {
            let split = o.split(FileKind.ResParseType.SUB_ITEM);
            let prop = Number(split[1]);
            if (data_control.isHitProbability(prop)) {
                return split[0];
            }
        }
        return null;
    }

    refreshTime() {
        this.labelDownTime.string = this.downTime + 's';
        if (this.downTime <= 0) {
            this.endGame();
        }
    }

    onClickClose() {
        this.bStartGame = false;
        this.destroyNode();
    }

    protected update(dt: number): void {
        if (!this.bStartGame) {
            return;
        }
        this.upDt += dt;
        if (this.upDt < 1) {
            return;
        }
        this.upDt = 0;
        this.downTime--;
        this.refreshTime();
    }
}
